import React from 'react'
import PropTypes from 'prop-types'
import loginStyle from '../../assets/jss/loginStyle'
import GridContainer from '../../components/Grid/GridContainer'
import GridItem from '../../components/Grid/GridItem'
import { Field, reduxForm } from 'redux-form'
import {
    renderTextField
} from '../form/RenderComponent'
import {
 FORM_LOGIN
} from '../../utils/CommonConstant'
import { 
    withStyles, 
    Button 
} from '@material-ui/core';

const LoginForm = (props) =>{
    const {classes, handleSubmit, submitting} = props

    return (
        <form onSubmit={handleSubmit}>

            <GridContainer>

                <GridItem xs={12} sm={12} md={12}>
                    <div className="CenterHorizontal">
                        <h3>
                            Job Portal Admin
                        </h3>
                    </div>
                    
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <Field
                        name="email"
                        label="Email"
                        component={renderTextField}
                        style={classes.input}
                        type="email"
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <Field
                        name="password"
                        label="Password"
                        component={renderTextField}
                        type="password"
                        style={classes.input}
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                    <div className="CenterHorizontal">
                        <Button
                            className={classes.button}
                            type="submit" 
                            disabled={submitting}
                            variant='contained'
                            color='secondary'>
                            Login
                        </Button>
                    </div>
                </GridItem>

            </GridContainer>

        </form>
    )
}

LoginForm.propTypes = {
    classes: PropTypes.object.isRequired
}

export default reduxForm({
    form: FORM_LOGIN,
    destroyOnUnmount: true,
    enableReinitialize: false,
    forceUnregisterOnUnmount: true,
    initialValues:{
        email: "",
        password: ""
    }
})(withStyles(loginStyle)(LoginForm))